import UserRoutes from './user-routes';
import AdminRoutes from './admin-routes';
import SuperadminRoutes from './superadmin-routes';

export const routes = new Map()
  .set('user', UserRoutes)
  .set('admin', AdminRoutes)
  .set('superadmin', SuperadminRoutes);
